
























































































































































































































































import { Vue } from "../../constants/constants";
import { staticContent } from "../../localisation/detect-lang";
import { BasketLoadersEnum } from "../../models/basket.model";

export default Vue.component("order-receipt", {
  data() {
    return {
      staticContent,
      basketLoader: BasketLoadersEnum,
    };
  },
  props:['page'],
  mounted(){
    console.log('reciet type',this.page)
  },
 
  computed: {
  getMyOrdersLoadingDataError() {
      return this.$root.myOrdersLoadingDataError;
    },
    OrderType() {
      return this.$store.state.selectedOrderType;
    },

    selectedOrder() {
      return this.$store.state.selectedOrder;
    },
    bindConditionalClasses() {
      return this.$root.bindConditionalClasses;
    },
    getMyOrdersGroupUsers() {
      return this.$root.getMyOrdersGroupUsers;
    },
    noOfUsers() {
      let users = this.getMyOrdersGroupUsers;
      return users ? users.length : 0;
    },
  },

  methods: {

  
   
    toFixedPrice(price) {
      return this.$root.toFixedPrice(price);
    },
    newCalcExtrasTotalPrice(total) {
      return this.$root.newCalcExtrasTotalPrice(total);
    },
    getOrderItemsCount(item) {
      return this.$root.getOrderItemsCount(item);
    },
    basketLoadersEnum() {
      return this.$root.basketLoadersEnum;
    },
    toggleActive(id, type, orderType, orderUUID) {
      this.$root.toggleActive(id, type, orderType, orderUUID);
    },
    tabsHandler(parentId, targetId) {
      this.$root.tabsHandler(parentId, targetId);
    },
    getMyOrdersLoadingData() {
      return this.$root.myOrdersLoadingData;
    },

  }
});
